import React from 'react';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import MatManImage from 'assets/images/tour/MatManShadow.png';

const altT = (key) => translate('alt', key);

type Props = {
  imageClass?: any;
};

const MatMan: React.FC<Props> = ({ imageClass }) => {
  return (
    <>
      <div>
        <img src={MatManImage} className={imageClass} alt={altT('Mat Man')} />
      </div>
    </>
  );
};

export default MatMan;
